// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"84":"62247f835b65db7a","953":"512e9ebb8d6e9c46"}[chunkId] + ".js";
};